import { Injectable, TemplateRef } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  ColumnaFuenteDatosEstructura,
  Dropdown,
  ModalSelect,
  Custom,
  Textbox
} from '@app/shared';


@Injectable()
export class ReportsStructureDataFormService {

  constructor() { }

  /**
   * Retorna el formulario para agregar una fuente de dato a la columna del reporte
   *
   * @param {*} options
   * @param {TemplateRef<any>} template
   * @param {ColumnaFuenteDatosEstructura} [datValue]
   * @param {boolean} [listForm=false]
   * @returns {BaseControl<any>[]}
   * @memberof ReportsStructureDataFormService
   */
  getForm(
    options: any,
    template: TemplateRef<any>,
    datValue?: ColumnaFuenteDatosEstructura,
    listForm: boolean = false
  ): BaseControl<any>[] {
    const val = options['parametersInternal'] ? options['parametersInternal'].length ? false : true : true;
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'txtTramite',
        label: 'Trámite seleccionado',
        value: options['tramiteSelected'] ? options['tramiteSelected'] : 'Pendiente de configurar (endpoint)',
        order: 1,
        disabled: true
      }),
      new Dropdown({
        key: 'cboTipoDato',
        label: 'Tipo de dato para la fuente:',
        value: datValue ?
                datValue.hasOwnProperty('campo_interno') ?
                  'campo_interno'
                : (datValue.campo_tabla || datValue.campo_forma) ?
                  'campo_forma'
                : datValue.tarea_documento ?
                  'documento'
                : null
               : null,
        options: [
          {key: 'campo_interno', value: 'Campo interno'},
          {key: 'campo_forma', value: 'Campo forma'},
          {key: 'documento', value: 'Documento'},
        ],
        order: 2,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Dropdown({
        key: 'cboCampoInterno',
        label: 'Campo interno:',
        value: datValue ?
                datValue.campo_interno ?
                  datValue.campo_interno[0] ?
                    datValue.campo_interno[0]
                  : null
                : null
               : null,
        options: [
          {key: 'tramite', value: 'Trámite'},
          {key: 'tramite-estado', value: 'Estado del trámite'},
          {key: 'tramite-expediente', value: 'Expediente del trámite'},
          {key: 'actividad', value: 'Actividad'},
          {key: 'actividad-estado', value: 'Estado de la actividad'},
          {key: 'tarea-fecha-activacion', value: 'Fecha de activación de la tarea'},
          {key: 'tarea-fecha-finalizacion', value: 'Fecha de finalización de la tarea'},
          {key: 'tarea-estado', value: 'Estado de la tarea'},
          {key: 'tarea-responsables', value: 'Responsables de la tarea'},
        ],
        order: 3,
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'cboTipoDato',
            siEs: 'Igual',
            valor: 'campo_interno',
            accion: 'Mostrar'
          }
        ]
      }),
      new Dropdown({
        key: 'cboParametroDocumento',
        label: 'Dato del documento:',
        value: datValue ?
                datValue.tarea_documento ?
                  datValue.tarea_documento.length ?
                    datValue.tarea_documento[0] ?
                      datValue.tarea_documento[0]
                    : null
                  : null
                : null
               : null,
        options: [
          {key: 'radicado', value: 'Radicado'},
          {key: 'fecha-radicado', value: 'Fecha del radicado'},
        ],
        order: 4,
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'cboTipoDato',
            siEs: 'Igual',
            valor: 'documento',
            accion: 'Mostrar'
          }
        ]
      }),
      new ModalSelect({
        key: 'cboDocumento',
        label: 'Documento:',
        data: options['documents'] ? options['documents'] : [],
        value: datValue ?
                datValue.tarea_documento ?
                  datValue.tarea_documento.length ?
                    datValue.tarea_documento[1] ?
                      datValue.tarea_documento[1]
                    : null
                  : null
                : null
               : null,
        keyValue: 'id',
        columns: [
          {key: 'nombre', label: 'Nombre'},
          {key: 'tipo_documental', label: 'Tipo documental'},
          {key: 'subserie', label: 'Subserie'},
        ],
        order: 5,
        placeholder: 'Seleccionar el documento en el cual se realizara la accion',
        validations: {
          validators: [Validators.required]
        },
        classModal: 'modal-lg-personalized',
        class: 'form-control',
        actionAdd: false,
        actionUpdate: false,
        actionDelete: false,
        condictions: [
          {
            campoDepende: 'cboTipoDato',
            siEs: 'Igual',
            valor: 'documento',
            accion: 'Mostrar'
          }
        ]
      }),
      new Dropdown({
        key: 'cboTipoFormulario',
        label: 'Tipo de fuente:',
        value: datValue ?
                datValue.campo_forma ?
                  'formulario'
                : datValue.campo_tabla ?
                  'tabla'
                : null
               : null,
        options: [
          {key: 'formulario', value: 'Formulario'},
          {key: 'tabla', value: 'Tabla'},
        ],
        order: 6,
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'cboTipoDato',
            siEs: 'Igual',
            valor: 'campo_forma',
            accion: 'Mostrar'
          }
        ]
      }),
      new Custom({
        key: 'cboCampo',
        label: 'Campo',
        order: 7,
        template: template,
        placeholder: 'Seleccione un campo de los formularios de la tarea',
        value: datValue ?
                datValue.campo_forma ?
                  datValue.campo_forma.length ?
                    datValue.campo_forma[0] ?
                      datValue.campo_forma[0]
                    : null
                  : null
                : null
               : null,
        options: options['optionsCampos'],
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'cboTipoDato',
            siEs: 'Igual',
            valor: 'campo_forma',
            accion: 'Mostrar',
            operadorCondicion: 'Y'
          },
          {
            campoDepende: 'cboTipoFormulario',
            siEs: 'Igual',
            valor: 'formulario',
            accion: 'Mostrar'
          }
        ],
        parameters: {
          multiple: false
        }
      }),
    ];
    // Se valida si hay campos internos
    if (options['parametersInternal'] && options['parametersInternal'].length) {
      controls.push(
        new Custom({
          key: 'cboParametroInterno',
          label: 'Parametro',
          order: 3,
          describe: 'Seleccione un parametro de el campo interno',
          template: options['templateList'],
          placeholder: 'Seleccione un parametro de el campo interno',
          value: datValue ?
                  datValue.campo_interno ?
                    this.formParameterInternal(datValue.campo_interno)
                  : null
                : null,
          options: options['parametersInternal'] ?
                    options['parametersInternal'].length ?
                     options['parametersInternal']
                    : []
                   : [],
          validations: options['parametersInternal'] ?
                        options['parametersInternal'].length ?
                          { validators: [Validators.required] }
                        : {}
                       : {},
          hidden: val,
          condictions: [
            {
              campoDepende: 'cboTipoDato',
              siEs: 'Igual',
              valor: 'campo_interno',
              accion: 'Mostrar',
              operadorCondicion: 'Y'
            },
          ],
          parameters: {
            multiple: false
          }
        }),
      );
    }
    if (listForm) {
      const valueList: any[] = [];
      if (datValue.campo_forma && typeof datValue.campo_forma === 'object' && datValue.campo_forma.length) {
        datValue.campo_forma.forEach((el, index) => {
          if (index > 0) {
            valueList.push(el);
          }
        });
      }

      controls.push(
        new Custom({
          key: 'cboListCampoForm',
          label: 'Posiciones a mostrar',
          order: 8,
          describe: 'Seleccione las posiciones de las columnas de la lista que desea mostrar',
          template: options['templateList'],
          placeholder: 'Seleccione las posiciones de las columnas de la lista que desea mostrar',
          value: valueList,
          options: options['listPositions'],
          validations: {
            validators: [Validators.required]
          },
          condictions: [
            {
              campoDepende: 'cboTipoDato',
              siEs: 'Igual',
              valor: 'campo_forma',
              accion: 'Mostrar',
              operadorCondicion: 'Y'
            },
            {
              campoDepende: 'cboTipoFormulario',
              siEs: 'Igual',
              valor: 'formulario',
              accion: 'Mostrar'
            }
          ],
          parameters: {
            multiple: true
          }
        })
      );
    }

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Retorna el formulario de agregar una columna de las tablas del formulario
   *
   * @param {*} options
   * @param {TemplateRef<any>} template
   * @param {*} [datValue]
   * @param {boolean} [listForm=false]
   * @returns {BaseControl<any>[]}
   * @memberof ReportsStructureDataFormService
   */
  getFormColumns(
    options: any,
    template: TemplateRef<any>,
    datValue?: any,
    listForm: boolean = false
  ): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboCampoTabla',
        label: 'Columna',
        order: 1,
        template: template,
        placeholder: 'Seleccione una columna de las tablas de la tarea',
        value: datValue ?
                datValue.nombre_campo ?
                    datValue.nombre_campo
                : null
               : null,
        options: options['optionsColumns'],
        validations: {
          validators: [Validators.required]
        }
      }),
    ];

    if (listForm) {
      controls.push(
        new Custom({
          key: 'cboListCampoForm',
          label: 'Posiciones a mostrar',
          order: 2,
          describe: 'Seleccione las posiciones de las columnas de la lista que desea mostrar',
          template: options['templateList'],
          placeholder: 'Seleccione las posiciones de las columnas de la lista que desea mostrar',
          value: datValue ? datValue.posiciones ? datValue.posiciones : [] : [],
          options: options['listPositionsColumns'],
          validations: {
            validators: [Validators.required]
          },
          parameters: {
            multiple: true
          }
        })
      );
    }

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Retorna el parametro seleccioando de el campo interno
   *
   * @private
   * @param {(string | string[])} campoInternal
   * @returns {string}
   * @memberof ReportsStructureDataFormService
   */
  private formParameterInternal(campoInternal: string | string[]): string {
    let parameter = '';
    if (typeof campoInternal === 'string') {
      campoInternal = campoInternal.split('_');
    }
    if (campoInternal && campoInternal.length) {
      campoInternal.forEach((el, i) => {
        if (i > 0) {
          parameter += el;
          if (i !== (campoInternal.length - 1)) {
            parameter += '_';
          }
        }
      });
    }
    return parameter ? parameter : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/reports-structure/reports-structure-data/shared/reports-structure-data.form.service.ts